import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nResources } from './resources.js';
import { parseRoute, getPageLocale, isSupportedLocale } from '../routes.js';

const initialRoute = typeof window !== 'undefined' ? parseRoute(window.location.pathname) : { locale: 'en', page: 'home' };
const queryLocale = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('lng') : null;
const initialLocale = getPageLocale(initialRoute.page, isSupportedLocale(queryLocale) ? queryLocale : initialRoute.locale);

i18n.use(initReactI18next).init({
  resources: i18nResources,
  lng: initialLocale,
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
